<template lang="html">
  <div class="animated fadeIn">
    <b-card>
      <b-button-toolbar class="pull-right">
        <b-btn variant="primary" @click="showAddProfile">Add Satsangi Profile</b-btn>
      </b-button-toolbar>
    </b-card>

    <b-card>
      <b-row>
        <b-col lg="6" class="my-1">
        <b-form-group
          label="Filter"
          label-align-sm="left"
          label-size="lg"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="6" class="my-1">
       <b-form-group
         label="Sort"
         label-align-sm="left"
         label-size="lg"
         label-for="sortBySelect"
         class="mb-0"
       >
         <b-input-group size="sm">
           <b-form-select v-model="sortBy" id="sortBySelect" :options="sortOptions" class="w-75">
             <template #first>
               <option value="">-- none --</option>
             </template>
           </b-form-select>
           <b-form-select v-model="sortDesc" size="sm" :disabled="!sortBy" class="w-25">
             <option :value="false">Asc</option>
             <option :value="true">Desc</option>
           </b-form-select>
         </b-input-group>
       </b-form-group>
     </b-col>

    </b-row>
    <hr/>
      <b-row>
        <b-col>
          <b-table hover :busy="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter"  @filtered="onFiltered" :current-page="currentPage" :per-page="perPage" :items="profiles" :fields="fields" id="dataTable" ref="dataTable" responsive="sm">
            <template #table-busy>
               <div class="text-center text-danger my-2">
                 <b-spinner class="align-middle"></b-spinner>
                 <strong>Loading...</strong>
               </div>
            </template>
            <template v-slot:cell(houseno)="row">
              <b>{{ row.value}}</b>
            </template>
            <template v-slot:cell(show_details)="row">
                <b-button size="sm" @click="showBhaintTypes(row)" class="mr-2">
                  {{ row.detailsShowing ? 'Hide' : 'Show'}} Bhaint Types
                </b-button>
            </template>
            <template v-slot:cell(actions)="row">
              <b-btn size="sm" variant="outline-primary" @click="showEditProfile(row)" class="mr-1">Edit</b-btn>
              <b-btn size="sm" variant="outline-primary" @click="showPayDues(row)" class="mr-1">Pay Dues</b-btn>
            </template>
            <template v-slot:row-details="row">
               <b-table table-variant="info" striped  :fields="detailsFields" :items="row.item.profileCharges"></b-table>
               <b-button size="sm" @click="row.toggleDetails">Hide Bhaint Types</b-button>
            </template>

          </b-table>
        </b-col>
      </b-row>
        <b-row >
          <b-col v-if="profiles!=null && Object.keys(profiles).length > 0 && this.isBusy == false" class="text-center">
            <b-pagination
               v-model="currentPage"
               :total-rows="totalRows"
               :per-page="perPage"
               align="fill"

               class="my-0">
           </b-pagination>
          </b-col>
        </b-row>
    </b-card>
    <div>
      <b-modal scrollable  size="lg" hide-footer  no-close-on-backdrop no-close-on-esc ref="modalEditProfile" title="Edit Satsangi Profile" hide-footer @hide="hideEditProfile">
        <profile-edit v-if="selectedProfile" :profile="selectedProfile" @success="editProfileSuccess" @cancel="cancelEditProfile" />
      </b-modal>
    </div>
    <div>
      <b-modal scrollable  size="lg" hide-footer  no-close-on-backdrop no-close-on-esc ref="modalAddProfile" title="Add Satsangi Profile" hide-footer >
        <profile-add  @success="addProfileSuccess" @cancel="cancelAddProfile" />
      </b-modal>
    </div>
    <div>
      <b-modal ref="modalPaydues" title="Pay Dues" hide-footer @hide="hidePayDues">
        <pay-dues v-if="selectedProfile" :profile="selectedProfile" @success="payDuesSuccess" @cancel="cancelPayDues" />
      </b-modal>
    </div>
  </div>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import Vue from 'vue'
  import ProfileEdit from './SatsangiProfileEdit'
  import ProfileAdd from './SatsangiProfileAdd'
  import PayDues from './PayDuesForm'

  export default {
    name: 'ProfileList',
    components: {
      ProfileEdit,
      ProfileAdd,
      PayDues
    },

    data: function() {
      return {
        totalRows: 1,
        sortBy: '',
        currentPage: 1,
        sortDesc: false,
        perPage: 50,
        filter: null,
        isBusy: false,
        profileCharges: null,
        satsangiProfiles: [],
        selectedProfile: null,
        fields: [   {key:'name', label:'Satsangi Name',sortable: true, sortDirection: 'desc' },{key:'houseno',sortable: true, sortDirection: 'desc' , label:'House No'},
                    {key:'balance', label:'House Balance',sortable: true, sortDirection: 'desc' },
                    {key:'lastpayment',sortable: true, sortDirection: 'desc' , label:'Last Payment'},
                    {key:'show_details', label:'Bhaint Types'}, {key:'actions', label:'Actions'},

                ],
        detailsFields: [  {key:'name', label: 'Bhaint Name'},{key:'amount', label:'Amount'},
                          {key:'fixedcharges', label:'Fixed?',
                            formatter: (value, key, item) => {return value ? 'Yes' : 'No'},
                          }
                       ],

        useVuex: false,
        theme: 'bootstrap4',
        template: 'default',
      }
    },
    computed: {
      profiles(){
        return this.satsangiProfiles;

      },
      sortOptions() {
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
    methods: {
      showAddProfile(){
        this.$refs.modalAddProfile.show();
      },
      showPayDues(row){
        this.selectedProfile = row.item;
        this.$refs.modalPaydues.show();
      },
      cancelAddProfile() {
        this.$refs.modalAddProfile.hide()
      },
      addProfileSuccess() {
        this.$refs.modalAddProfile.hide();
        this.getProfiles();
      },
      getProfiles(){
        this.isBusy = true;
        axios
          .get("/electrical/profiles")
          .then(response => {this.satsangiProfiles = response.data.data;
                              this.totalRows = this.satsangiProfiles.length;
                              this.isBusy = false;
                            })
          .catch(error => {
            if (error.response.status == 400) {
              this.showErrorMsg({
                message: error.response.data.message
              })
            } else if (error.response.status == 422) {
              this.showErrorMsg({
                message: error.response.data.message
              })
            } else {
              this.showErrorMsg({ message: 'Something went wrong. Please contact administrator.' })
            }
            this.isBusy = false;
          });
      },
      getFixedChargeLable(chargeType){
         return chargeType.fixedcharges == true ? 'Yes' : 'No';
      },
      showEditProfile(row) {
        if (this.$store.state.electrical.electricLines.length == 0) {
          this.$store.dispatch('electrical/getElectricLines');
        }

        if (this.$store.state.electrical.satsangiGroups.length == 0) {
          this.$store.dispatch('electrical/getSatsangiGroups');
        }
        let param = {id : row.item.id};
        axios
        .post("/electrical/profile/getProfile", param , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
          .then(response => {
                            this.selectedProfile = response.data.data.data;
                            this.selectedProfile.electricline = this.$store.state.electrical.electricLines.find(item=>item.id==this.selectedProfile.electricline);
                            this.selectedProfile.groupid = this.$store.state.electrical.satsangiGroups.find(item=>item.id==this.selectedProfile.groupid);
                            this.$refs.modalEditProfile.show();
                            })
          .catch(error => {
            if (error.response.status == 400) {
              this.showErrorMsg({
                message: error.response.data.message
              })
            } else if (error.response.status == 422) {
              this.showErrorMsg({
                message: error.response.data.message
              })
            } else {
              this.showErrorMsg({ message: 'Something went wrong. Please contact administrator.' })
            }
          });


      },
      cancelEditProfile() {
        this.$refs.modalEditProfile.hide()
      },

      editProfileSuccess() {
        this.$refs.modalEditProfile.hide();
        this.getProfiles();
      },
      hideEditProfile() {
        this.selectedProfile = null
      },
      payDuesSuccess(){
        this.$refs.modalPaydues.hide();
        this.getProfiles();
      },
      cancelPayDues() {
        this.$refs.modalPaydues.hide();
      },
      hidePayDues() {
        this.selectedProfile = null;
      },
      showBhaintTypes(row){
        let params = {
          id : row.item.id
        }
        axios
        .post("/electrical/profile/getProfileCharges", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
          .then(response => {
                if (response.data.success == false) {
                  this.showErrorMsg({
                    message: response.data.error
                  })
                } else {
                  row.item.profileCharges = response.data.data.data;
                  row.toggleDetails();
                }
           })
          .catch(error => {
            if (error.response.status == 400) {
              this.showErrorMsg({
                message: error.response.data.message
              })
            } else if (error.response.status == 422) {
              this.showErrorMsg({
                message: error.response.data.message
              })
            } else {
              this.showErrorMsg({ message: 'Something went when wrong getting Bhaint Types. Please contact administrator.' })
            }
          });

      },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
    },
    created() {
      if (this.satsangiProfiles.length == 0) {
        this.getProfiles();
      }
    }
  }
</script>

<style lang="css">
</style>
